export default __webpack_public_path__ + "static/media/Group 8255.96360413.jpg";